<template>
  <VListItem id="ChangeLanguageListItem">
    <template v-slot:append>
      <VIcon>
        mdi-translate
      </VIcon>
    </template>
    <VListItemTitle>{{ availableLocales[selectedLocaleIndex].text }}</VListItemTitle>
  </VListItem>
  <VMenu
    open-on-hover
    activator="#ChangeLanguageListItem"
    location="left"
  >
    <VList>
      <VListItem
        v-for="(locale, i) in availableLocales"
        :key="locale.value"
        :active="selectedLocaleIndex === i"
        color="primary"
        @click="changeLocale(availableLocales[i].value)"
      >
        <VListItemTitle>{{ locale.text }}</VListItemTitle>
      </VListItem>
    </VList>
  </VMenu>
</template>

<script>
import LocaleMixin from '@/mixins/LocaleMixin';

export default {
  mixins: [LocaleMixin],
  computed: {
    selectedLocaleIndex: {
      get: function () {
        return this.availableLocales.findIndex((locale) => locale.value === this.currentLocale)
      }
    }
  },
  methods: {
  }
}
</script>

<style>

</style>
